import type { ColumnDef } from "@tanstack/react-table";
import { buildAvatarDetailsColumn, buildCopyTextColumn, buildTagColumn } from "@/components/Table";
import { renderEmptyCellState } from "@/components/Table/utils";
import { formatEnumLabel } from "../../_utils";
import type { CommissionEnrollmentNode } from "../types";

interface ColumnsOptions {
  isCompactLayout: boolean;
}

export function enrollmentPersonPgaId(row: CommissionEnrollmentNode): string | null {
  return row.person?.pgaId ?? null;
}

export function getColumns({ isCompactLayout }: ColumnsOptions): ColumnDef<CommissionEnrollmentNode, unknown>[] {
  return [
    ...buildAvatarDetailsColumn<CommissionEnrollmentNode>({
      isCompactLayout,
      getTitle: (row) => row.person?.displayName ?? "Unknown member",
      getSubtitle: (row) => row.person?.pgaId ?? undefined,
      header: "Member",
      size: 240,
      subtitleLabel: "PGA ID",
      id: "displayName",
      sortType: "text"
    }),
    buildCopyTextColumn<CommissionEnrollmentNode>({
      accessorKey: "pgaId",
      header: "PGA ID",
      getText: (row) => row.person?.pgaId ?? "",
      copyFieldLabel: "PGA ID",
      shouldShowCopyButton: (row) => !!row.person?.pgaId,
      enableSorting: false,
      size: 120
    }),
    {
      id: "program",
      accessorFn: (row) => row.program.name,
      header: "Program",
      size: 200,
      enableSorting: false,
      cell: ({ row }) => renderEmptyCellState(row.original.program.name)
    },
    buildTagColumn<CommissionEnrollmentNode>({
      accessorKey: "accountStatus",
      header: "Account status",
      size: 140,
      getTagLabel: (row) => formatEnumLabel(row.accountStatus),
      getTagType: (row) => (row.accountStatus === "ACTIVE" ? "success" : "surface"),
      getTagStyle: () => "strong"
    })
  ];
}
